import BaseModule from './base-module';

// 首页
class Home extends BaseModule {
  // 首页-今日概况-数量统计接口
  i_lis(params) {
    return this.post('/admin/i_lis', params);
  }
  // 首页-营收统计接口
  obtainOrde(params) {
    return this.post('/admin/i_lis/obtainOrder', params);
  }
  // 首页-订单数量金额统计
  chat(params) {
    return this.post('/admin/i_lis/chat', params);
  }
}

export default new Home();
